exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2n7iFIAen1JP3ypRoryrIY p {\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"kardiaRxPatient": "_2n7iFIAen1JP3ypRoryrIY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/containers/KardiaRxPatientResult/KardiaRxPatientResult.css
// module id = 9846
// module chunks = 23